import { call, select } from 'redux-saga/effects';

import get from 'lodash/get';
import { DEPENDENT_FORM_STEPS } from '../progress.actions';
import {
  selectDependentFormAssigmentId,
  selectDependentFormCurrentStep,
  selectDependentFormIsBackDisabled,
  selectDependentFormProgressMetadata,
} from '../selectors';
import {
  redirectHistoryBack,
  redirectToDocuments,
  redirectToGeneralInfo,
  redirectToRole,
} from './redirect-saga';

export function* handleBack() {
  const isBackDisabled = yield select(selectDependentFormIsBackDisabled);
  const assignmentId = yield select(selectDependentFormAssigmentId);
  const step = yield select(selectDependentFormCurrentStep);
  const metadata = yield select(selectDependentFormProgressMetadata);

  if (isBackDisabled) return;

  switch (step) {
    case DEPENDENT_FORM_STEPS.ROLE: {
      yield call(redirectHistoryBack);
      break;
    }
    case DEPENDENT_FORM_STEPS.PERSONAL: {
      yield call(redirectToRole);
      break;
    }

    case DEPENDENT_FORM_STEPS.DOCUMENTS: {
      yield call(redirectToGeneralInfo, assignmentId);
      break;
    }

    case DEPENDENT_FORM_STEPS.RELATION: {
      if (get(metadata, 'documentationStepEnabled')) {
        yield call(redirectToDocuments, assignmentId);
      } else {
        yield call(redirectToGeneralInfo, assignmentId);
      }
      break;
    }

    default: {
      break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/back-navigation-saga.js